import type { FaireProductEntity } from "../../entity_types/product";

export const p_4i33osnkcm: FaireProductEntity = {
  token: "p_4i33osnkcm",
  type: "product",
  name: "Sneaker Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/ebe100c60d4efe987cb86d126372e48cb75f710a0eefade9d3d0882a6fb3e181.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da0486f3e530902f0fe8c31ae779fd5b6732183868caf3bbd36157bb00fadec2.jpeg",
    "https://cdn.faire.com/fastly/d2f1f063466a44c69b0f5c768508b59d551d310f0593a652512f2a331e5c15a8.jpeg",
    "https://cdn.faire.com/fastly/2724f42196274063927372bfbc97d926925f05da901b0f7215e5afc655237374.jpeg",
    "https://cdn.faire.com/fastly/377751fa24418e292e42e343beb5eb7197e70704d0623bf8a1e2b37500b469c0.jpeg",
    "https://cdn.faire.com/fastly/387f0273bb27f65dfc4bbb877e72ca80d0479f0a09b6a2ed791a724f371c42e8.jpeg",
    "https://cdn.faire.com/fastly/c5dd4ab6a138859fad8434ed6f9b9efbe2c8cc5e52e5d29875a3197483f4a456.jpeg",
    "https://cdn.faire.com/fastly/287a924bdeacf3257ffd9673a6ec48f0b45ea8868bb987e7c23a31c00bd8afa7.jpeg",
    "https://cdn.faire.com/fastly/200f22eb9228281f917c48727a0983bf88ab214dc5a89913eefb6c0362548dd5.jpeg",
    "https://cdn.faire.com/fastly/89cfc27b86f9f52868db33daccd1904e50194287246a90b05846e5563c08a5aa.jpeg",
    "https://cdn.faire.com/fastly/675b6cf12290fdd0a58a4671c3f9710fa97223b3b9f37464942ecaf2ca0fee43.jpeg",
    "https://cdn.faire.com/fastly/b1833c8d15613c23304acddd834badd3625d9592eed581122cc349a51c356c5a.jpeg",
    "https://cdn.faire.com/fastly/d710014acb329e7e17416629c66bdcf13b34bdaadcb6f1ce76d5e0fce829a64d.jpeg",
    "https://cdn.faire.com/fastly/1642d8e0d8778fd7f6289cb1ab463ae409f9a4f842e378e4d6310099cc613c96.jpeg",
    "https://cdn.faire.com/fastly/3c3ada23b06c5d9daed299d40df91af608b23650c8c6013599dd17ef5a1ee3fe.jpeg",
    "https://cdn.faire.com/fastly/08889be07d15db69d2753005a2542e682351a6bf114c0aea87f14110de71433c.jpeg",
    "https://cdn.faire.com/fastly/6c4459c42ac5038e9dd3dff958002f7883f172cdff58b5f4a45505613ad04ad2.jpeg",
    "https://cdn.faire.com/fastly/05baf08deedb476dc36abc16226490fb39b17a48f178497dfdb1d0472b118f31.jpeg",
    "https://cdn.faire.com/fastly/c096fbdc02923b9cdb7373f71e5c7d7ffe20486f8be464a6888f5a79ec6026a1.jpeg",
    "https://cdn.faire.com/fastly/81e1bd9ebd883c5ca17970690a293885d76374a85baab5c8f0c77aef906246d7.jpeg",
    "https://cdn.faire.com/fastly/5b0e1359a37f32d9c78156d2c626050123c467aa97f7ba4e881634d426e6d1e2.jpeg",
    "https://cdn.faire.com/fastly/8f76b1fdda7540902926860e5665987b3b4d3af4928733c6b4d30d029dbc422d.jpeg",
    "https://cdn.faire.com/fastly/e79ae3d1e22467d46553dda5b14dc7296787b0391611fadfcf7e5b26f84ca49d.jpeg",
    "https://cdn.faire.com/fastly/21d631358ba7f0c8d6a7ec0bc4426376248384e273e825b3f7ffa435ed263b85.jpeg",
    "https://cdn.faire.com/fastly/1890a4b266075ae34959ea7ce472e63c15e0f95d69091e29f0eba7e85bf626de.jpeg",
    "https://cdn.faire.com/fastly/6e138a6ba0c2281d6ead5c6ce8cd6ba7c6eb02702031abf3f74126235a118026.jpeg",
    "https://cdn.faire.com/fastly/fa91b36ef8526d09964ac36f526abb411e94611608099f88d35e2a089f24eb14.jpeg",
  ],
  priceDollars: 5,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nGoing from workout to work? A breathable sock that you can sweat, dance, jump and play in without leaving a mark on your skin like most sock bands do! The perfect height made with a cotton blend, this breathable sock is perfectly suited for your favorite sneakers!\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n70 Cotton 28 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\n𝐌𝐒𝐑𝐏: $10 USD",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:54.690Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
